import { FC } from 'react';

import './NullScreen.scss';

export type Props = {
    text?: string;
};

export const NullScreen:  FC<Props> = ({text}) => {
    return(
        <div className="c-nullScreen">
            <div className='c-nullScreen__wrapper'>
                <h2>{text}</h2>
            </div>
        </div>
    );
};

